import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ErrorDotIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'ErrorDefault', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("circle", { cx: 12, cy: 12, r: 4, fill: primaryFillColor }) }));
}
//# sourceMappingURL=ErrorDot.js.map